import * as TYPES from './test-results-actiontypes';
import { extractTestResultsFilterOptions, filteredTestResults } from './test-results-filter-mapper';

export const LOCAL_STORAGE_KEY = 'patient:test-results';
const DEFAULT_DATE_FILTER = 'All';

export const initialState = {
  results: [],
  selectedTestResultIndex: null,
  notReviewedTestResultsCount: 0,
  selectedTestResult: {
    labResultGroups: [],
  },
  showFilterPanel: false,
  filter: {
    date: null,
    testProcedure: '',
    orderedBy: '',
  },
  filterOptions: {
    testProcedureList: [],
    orderedByList: [],
  },
};

export const getDefaultFilter = () => (
  {
    date: DEFAULT_DATE_FILTER,
    testProcedure: initialState.filter.testProcedure,
    orderedBy: initialState.filter.orderedBy,
  }
);

export const testResultsReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.TEST_RESULTS_LOADED_SUCCESS: {
      let dateFilter = (state.filter.date === null && action.userPreferenceDateFilter)
        ? action.userPreferenceDateFilter
        : state.filter.date;
      dateFilter = dateFilter || DEFAULT_DATE_FILTER;
      const filter = { ...state.filter, date: dateFilter };

      newState = { ...state,
        results: filteredTestResults(action.testResults, filter),
        filterOptions: extractTestResultsFilterOptions(action.testResults),
        filter };
      break;
    }
    case TYPES.SELECTED_TEST_RESULT_CHANGED:
      newState = { ...state, selectedTestResultIndex: action.selectedTestResultIndex };
      break;
    case TYPES.NEW_TEST_RESULTS_COUNT_LOADED:
      newState = { ...state, notReviewedTestResultsCount: action.notReviewedTestResultsCount };
      break;
    case TYPES.TESTRESULTS_FILTER_OPTIONS_CHANGED:
      newState = {

        ...state,
        selectedTestResultIndex: null,
        selectedTestResult: {
          labResultGroups: [],
        },
        filter: { ...state.filter, ...action.filter },
        results: filteredTestResults(state.results, action.filter) };
      break;
    case TYPES.TESTRESULTS_TOGGLE_FILTER_PANEL:
      newState = { ...state, showFilterPanel: action.showFilterPanel };
      break;
    case TYPES.TEST_RESULT_DETAILS_LOAD_SUCCESS: {
      const result = {
        labResultId: action.testResult.labResultId,
        startDate: action.testResult.startDate,
        externalStatus: action.testResult.externalStatus,
        isReviewedByPatient: action.testResult.isReviewedByPatient,
        requestingPhysician: action.testResult.requestingPhysician,
        labName: action.testResult.labName,
        comment: action.testResult.comment,
        noteToPatient: action.testResult.noteToPatient,
      };
      const resultGroups = action.testResult.testResultGroups.map((group) => {
        const newResultGroup = {
          testResultGroupId: group.testResultGroupId,
          groupDisplayName: group.groupDisplayName,
          testResultDetails: group.testResultDetails.map((details) => {
            const newResultDetails = {
              testResultDetailId: details.testResultDetailId,
              testDisplayName: details.testDisplayName,
              testValue: details.testValue,
              unitOfMeasure: details.unitOfMeasure,
              referencesRange: details.referencesRange,
              abnormalFlag: details.abnormalFlag,
              comment: details.comment,
              testDetailStatus: details.testDetailStatus,
            };
            return newResultDetails;
          }),
        };
        return newResultGroup;
      });
      result.labResultGroups = resultGroups;

      newState = { ...state, selectedTestResult: result };
      break;
    }
    default:
      newState = state;
  }

  return newState;
};

export default testResultsReducer;
